define('views/content/distributor_personals',['require','views/base/list_page_view','views/components/distributor_personal/distributor_personals','collections/distributor_personals','text!templates/content/distributor_personals.html'],function(require){

    var BaseListPageView = require('views/base/list_page_view');

    var DistributorPersonalsView = require('views/components/distributor_personal/distributor_personals');
    var DistributorPersonalsCollection = require('collections/distributor_personals');

    var temp = require("text!templates/content/distributor_personals.html");

    return BaseListPageView.extend({
        // html template for the view
        template: _.template(temp),
        className: 'distributor-personal-page',
        titleKey: 'personals',

        setCollection: function () {
            this.collection = new DistributorPersonalsCollection();
        },

        onRender: function() {
            this.ListContainer.show(new DistributorPersonalsView({
                collection: this.collection
            }));
        }

    });
});
